import { styled } from 'styled-components';
import { UIElements } from '@ansvar-sakerhet/ui';

const ControlsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  justify-content: flex-end;
  flex-wrap: wrap;
  min-width: 0;
`;

const ControlsContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 160px - 68px - 48px);
  justify-content: space-between;
`;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 64px 24px;
  text-align: center;
`;

export const S = {
  ...UIElements,
  ControlsHeader,
  HeaderActions,
  ControlsContainer,
  EmptyState,
};
